import { useEffect } from "react";
import { useLocation, matchRoutes, useNavigate } from "react-router-dom";
import routers, { basePath } from "../routes";
import { CreditsVault } from "@/api/type";

const AuthRoute = ({ children, auth }: any) => {
	const location = useLocation();
	const navigate = useNavigate();
	const token = localStorage.getItem("token") || "";
	const matches = matchRoutes(routers, location);
	const isCredits = window.location.href.toLowerCase().includes(CreditsVault);

	const isExist = matches?.some(
		(item) => item.pathname === location.pathname
	);

	useEffect(() => {
		if (!token && auth) {
			navigate(`${basePath}login`);
			return;
		}

		// 确保根路径重定向
		if (token && location.pathname === "/") {
			if (isCredits) {
				navigate("/vaultManage", {
					replace: true,
					state: { from: location.pathname },
				});
			} else {
				navigate("/game", {
					replace: true,
					state: { from: location.pathname },
				});
			}
			return;
		}
	}, [location.pathname, token, isExist, auth, navigate, isCredits]);

	return children;
};

export default AuthRoute;
